import { z } from 'zod';

export const valueDtoSchema = {
  co2: z.object({
    score: z.number(),
  }),
};

export const referencesDtoSchema = z.object({
  sectors: z.object({
    artists: z.object({
      co2: valueDtoSchema.co2,
    }),
    team: z.object({
      co2: valueDtoSchema.co2,
    }),
    public: z.object({
      co2: valueDtoSchema.co2,
    }),
    site: z.object({
      co2: valueDtoSchema.co2,
    }),
  }),
});
